angular.module('impactx.customerservice').component('ixCustomerServicePanel', {
        controller: 'CustomerServicePanelCtrl',
        templateUrl: 'modules/customerservice/templates/customer-service-panel.html'
    }
);
